import React from 'react'
import Image, { type StaticImageData } from 'next/image'
import visitsPhone from '@/assets/images/refresh/category-hero/visits-phone.png'
import labsPhone from '@/assets/images/refresh/category-hero/labs-phone.png'
import medicationsPhone from '@/assets/images/refresh/category-hero/medications-phone.png'
import specialistsPhone from '@/assets/images/refresh/category-hero/specialists-phone.png'
import classes from './Phone.module.css'

export type CategoryHeroPhoneKey = 'visits' | 'labs' | 'medications' | 'specialists'

const PHONE_IMAGES: Record<CategoryHeroPhoneKey, StaticImageData> = {
    visits: visitsPhone,
    labs: labsPhone,
    medications: medicationsPhone,
    specialists: specialistsPhone,
}

interface PhoneProps {
    phone: CategoryHeroPhoneKey
}

/** Renders the keyed phone crop as-is (chrome + visible screen are baked into the asset). */
export default function Phone({ phone }: PhoneProps) {
    const src = PHONE_IMAGES[phone]
    if (src == null) return null

    return (
        <div className={classes.root} aria-hidden>
            <Image
                src={src}
                alt=""
                width={src.width}
                height={src.height}
                sizes="(max-width: 48em) 280px, min(426px, 34vw)"
                className={classes.image}
                decoding="async"
            />
        </div>
    )
}
